import Vue from 'vue'
import Router from 'vue-router'

import http from "../util/http"
import store from '@/store'
import api from '../util/api.js'
import {Message} from 'element-ui'
Vue.use(Router)

const routes = [
	{
		path: '/',
		component: () => import('@/components/index/Index.vue')
	},
	{
		path: '/order',
		component: () => import('@/components/config')
	},
	// {
	// 	path: '/order',
	// 	name: 'Order',
	// 	component: () => import('@/components/order/Order')
	// },
	{
		path: '/carOverview',
		name: 'CarOverview',
		component: () => import('@/components/car/Overview')
	},
	{
		path: '/search',
		name: 'Search',
		component: () => import('@/components/search/Search')
	},
	{
		path: '/personInfo',
		name: 'PersonInfo',
		component: () => import('@/components/member/PersonInfo'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		},
		children: [
			{
				path: '/personOverView',
				name: 'personOverView',
				component: () => import('@/components/member/personOverView'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myOrderList',
				name: 'myOrderList',
				component: () => import('@/components/member/MyOrderList'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myPreOrder',
				name: 'myPreOrder',
				component: () => import('@/components/member/MyPreOrder'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/mybooklist',
				name: 'mybooklist',
				component: () => import('@/components/member/MyBookList'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/mybookdetail',
				name: 'myBookDetail',
				component: () => import('@/components/member/MyBookDetail'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myCommentList',
				name: 'myCommentList',
				component: () => import('@/components/member/MyCommentList'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myInformation',
				name: 'myInformation',
				component: () => import('@/components/member/MyInformation'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myInformationEdit',
				name: 'myInformationEdit',
				component: () => import('@/components/member/MyInformationEdit'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myProfilepictureEdit',
				name: 'myProfilepictureEdit',
				component: () => import('@/components/member/MyProfilepictureEdit'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/personalProfile',
				name: 'personalProfile',
				component: () => import('@/components/member/PersonalProfile'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myFavoriteList',
				name: 'myFavoriteList',
				component: () => import('@/components/member/MyFavoriteList'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myCollectionList',
				name: 'myCollectionList',
				component: () => import('@/components/member/MyCollectionList'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			},
			{
				path: '/myFreshCode',
				name: 'myFreshCode',
				component: () => import('@/components/member/MyFreshCode'),
				meta: {
					requireAuth: true  // 这个路由是需要登录的
				}
			}
		],
		redirect: '/personOverView'
	},
	{
		path: '/myViewEvaluation',
		name: 'myViewEvaluation',
		component: () => import('@/components/member/MyViewEvaluation'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/myCollections',
		name: 'myCollections',
		component: () => import('@/components/member/MyCollections'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/myFineQuality',
		name: 'myFineQuality',
		component: () => import('@/components/member/MyFineQuality'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/myCommentDetail',
		name: 'myCommentDetail',
		component: () => import('@/components/member/MyCommentDetail'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/appendMyCommentlist',
		name: 'appendMyCommentlist',
		component: () => import('@/components/member/AppendMyCommentlist'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/placeOrder',
		name: 'PlaceOrder',
		component: () => import('@/components/order/PlaceOrder'),
		meta: {
			requireAuth: false  // 添加该字段，表示进入这个路由是需要登录的
		}
	},
	{
		path: '/myOrderDetail',
		name: 'myOrderDetail',
		component: () => import('@/components/member/MyOrderDetail'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/myPreOrderDetail',
		name: 'myPreOrderDetail',
		component: () => import('@/components/member/MyPreOrderDetail'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/OrderPay',
		name: 'OrderPay',
		component: () => import('@/components/order/OrderPay'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/PreOrderPay',
		name: 'PreOrderPay',
		component: () => import('@/components/order/PreOrderPay'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/WechatPay',
		name: 'WechatPay',
		component: () => import('@/components/order/WechatPay'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/toPay',
		name: 'ToPay',
		component: () => import('@/components/order/ToPay'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/login',
		redirect: '/login/registerorsginIn',
		name: 'login',
		component: () => import('@/components/login/login'),
		children: [
			{
				path: 'registerorsginIn',
				name: 'registerorsginIn',
				component: () => import('@/components/login/registerorsginIn')
			},
			{
				path: 'completematerial',
				name: 'completematerial',
				component: () => import('@/components/login/completematerial')
			},
			{
				path: 'forgetpassword',
				name: 'forgetpassword',
				component: () => import('@/components/login/forgetpassword')
			},
			{
				path: 'bindphone',
				name: 'bindphone',
				component: () => import('@/components/login/bindphone')
			},
			{
				path: 'protocol',
				name: 'protocol',
				component: () => import('@/components/login/components/protocol')
			}
		]
	},
	{
		path: '/thirdlogin',
		redirect: '/thirdlogin/thirdsign',
		name: 'thirdlogin',
		component: () => import('@/components/login/thirdlogin'),
		children: [
			{
				path: 'thirdsign',
				name: 'thirdsign',
				component: () => import('@/components/login/components/thirdsign')
			},
			{
				path: 'thirdfailure',
				name: 'thirdfailure',
				component: () => import('@/components/login/components/thirdfailure')
			},
			{
				path: 'thirdsuccess',
				name: 'thirdsuccess',
				component: () => import('@/components/login/components/thirdsuccess')
			}
		]
	},
	{
		path: '/fresh',
		name: 'fresh',
		component: () => import('@/components/fresh/index'),
		meta: {
			requireAuth: true  // 这个路由是需要登录的
		}
	},
	{
		path: '/freshShare',
		name: 'FreshShare',
		component: () => import('@/components/fresh/FreshShare')
	},
	{
		path: '/activity',
		name: 'activity',
		component: () => import('@/components/reward-distribution/reward-distribution.vue')
	},
	{
		path: '/policy',
		name: 'policy',
		component: () => import('@/components/policy/index.vue')
	},

	{
		path: '404',
		name: 'maintenance',
		component: () => import('@/components/common/maintenance')
	},
	{
		path: '*',
		component: () => import('@/components/common/maintenance')
	}
]
const router = new Router({
	// mode: 'history',
	routes: routes
});

router.beforeEach((to, from, next) => {
	getLoc().then(() => {
		const {guideActivity = '',guidePlatform = ''} = to.query
		guideActivity && sessionStorage.setItem('guideActivity',guideActivity)
		guidePlatform && sessionStorage.setItem('guidePlatform',guidePlatform)

		if (to.path === 'freshShare') {
			document.title = to.query.title;
		} else {
			document.title = '吉利官方商城';
		}
		let apiKey = to.query.apiKey;
		let that = this;
		if (apiKey) {
			var params = {apiKey: apiKey};
			http.get('/mapi/member/getClubUserInfo', params).then(response => {
				if (response.data.code === 'success') {
					that.noregister = true;
					localStorage.setItem("apiKey", response.data.data);
					const currentDate = new Date().getTime();
					localStorage.setItem('apiKeyDate', currentDate);
				} else {
					that.noregister = false;
					localStorage.removeItem("apiKey");
					localStorage.removeItem("apiKeyDate");
				}
				loginChk(to, from, next);
			}).catch(error => {
				console.log(error)
			})
		} else {
			loginChk(to, from, next);
		}
	})
});
router.afterEach((to,from,next) => {
	window.scrollTo(0,0)
})
router.afterEach((to,from,next) => {
	setTimeout(() => {
		(function() {
			//每次执行前，先移除上次插入的代码
			document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			var hm = document.createElement("script");
			hm.src = "https://hm.baidu.com/hm.js?bb8313e6704bc3816a8be8a84ea790f9";
			hm.id = 'baidu_tj';
			var s = document.getElementsByTagName("script")[0];
			s.parentNode.insertBefore(hm, s);
		})();
	},0)
})

function loginChk(to, from, next) {
	if (to.matched.some(r => r.meta.requireAuth)) {
		let apiKey = localStorage.getItem('apiKey');
		const apiKeyDate = Number(window.localStorage.getItem('apiKeyDate'));
		const currentDate = new Date().getTime();
		const utc = currentDate - apiKeyDate;
		const day = utc / (24 * 60 * 60 * 1000);
		if (apiKey && day < 1) {
			next();
		} else {
			localStorage.setItem('historyPath', to.path);
			if (JSON.stringify(to.params) === '{}') {
				localStorage.setItem('historyParam', JSON.stringify(to.query));
			} else {
				localStorage.setItem('historyParam', JSON.stringify(to.params));
			}
			next({
				path: '/login/registerorsginIn?stepId=sign'
			})
		}
	} else {
		next();
	}
}
async function getLoc() {
	if(Object.keys(store.state.locInfo).length) {
		return new Promise((resolve, reject) => {
			resolve()
		})
	}
	return new Promise((resolve, reject) => {
		function getDepartment() {
			const locInfo = store.state.locInfo
			const config = {
				regionName: encodeURIComponent(locInfo.province)
			}
			api.getBusinessDepartment({},config).then(res => {
				const {code,data,message} = res.data
				if(code === 'success') {
					store.commit('department',data)
					console.log(store.state.locInfo,'IP定位所在的城市')
					console.log(store.state.department,'事业部')
					resolve()
				}else{
					store.commit('department','QUAN_GUO')
					Message.error(message)
					resolve()
				}
			}).catch(() => {
				store.commit('department','QUAN_GUO')
				resolve()
			})
		}
		const mapObj = new AMap.Map('iCenter');
		mapObj.plugin('AMap.Geolocation', function () {
			const geolocation = new AMap.Geolocation({
				enableHighAccuracy: true,//是否使用高精度定位，默认:true
				timeout: 10000,          //超过10秒后停止定位，默认：无穷大
				maximumAge: 0,           //定位结果缓存0毫秒，默认：0
				convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
				showButton: true,        //显示定位按钮，默认：true
				buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
				buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
				showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
				showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
				panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
				zoomToAccuracy: true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
			});
			mapObj.addControl(geolocation);
			geolocation.getCurrentPosition();
			geolocation.getCityInfo((status,result) => {
				console.log(result)
				store.commit('locInfo',{
					lat: result.center[1],
					lng: result.center[0],
					province: result.province,
					city: result.city
				})
				getDepartment()
			})
			// AMap.event.addListener(geolocation, 'complete', (result) => {
			// 	geolocation.getCityInfo((status,result2) => {
			// 		console.log(result,result2)
			// 		store.commit('locInfo',{
			// 			lat: result.position.lat,
			// 			lng: result.position.lng,
			// 			province: result2.province,
			// 			city: result2.city
			// 		})
			// 		getDepartment()
			// 	})
			// });//返回定位信息
			// AMap.event.addListener(geolocation, 'error', (error) => {
			// 	console.log(error,233)
			// 	geolocation.getCityInfo((status,result2) => {
			// 		console.log(result2)
			// 		store.commit('locInfo',{
			// 			lat: result2.center[1],
			// 			lng: result2.center[0],
			// 			province: result2.province,
			// 			city: result2.city
			// 		})
			// 		getDepartment()
			// 	})
			// });
		});
	})
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js